import classNames from 'classnames';
import React from 'react';

import {StaticPriceText} from '@udemy/browse-course';
import {Icon} from '@udemy/icons';
import {Tooltip} from '@udemy/react-popup-components';
import {PURCHASE_PRICE_TYPES, Price as UdemyShoppingPrice, Buyable} from '@udemy/shopping';

import styles from './shopping-item.module.less';
import {Discount} from './types';

interface PriceProps {
    isUB: boolean;
    buyable: Buyable;
    listPrice?: UdemyShoppingPrice;
    purchasePrice?: UdemyShoppingPrice;
    currentDiscount?: Discount;
    shouldUseLatestDiscountStyles?: boolean;
}

export const Price: React.FC<PriceProps> = ({
    isUB,
    buyable,
    listPrice,
    purchasePrice,
    currentDiscount,
    shouldUseLatestDiscountStyles = false,
}) => {
    if (isUB || !listPrice || !purchasePrice) {
        return null;
    }

    return (
        <div className={styles['price-container']}>
            <StaticPriceText
                className={classNames(styles.price, {
                    [styles['price-discounted-styles']]: shouldUseLatestDiscountStyles,
                })}
                listPriceClassName={styles['price-text']}
                discountPriceClassName={styles['price-text']}
                discountPrice={purchasePrice.amount}
                discountPriceString={purchasePrice.price_string}
                listPrice={listPrice.amount}
                listPriceString={listPrice.price_string}
                trackingEventContext={{
                    buyableId: buyable.id,
                    priceType: PURCHASE_PRICE_TYPES.individual_buyable,
                    buyableType: 'course',
                    buyableTrackingId: buyable.frontendTrackingId || buyable.tracking_id,
                }}
            />
            {currentDiscount?.code &&
                currentDiscount.is_public &&
                currentDiscount.campaign?.show_code && (
                    <Tooltip
                        placement="left"
                        className={styles['coupon-icon-tooltip']}
                        udStyle="white"
                        trigger={
                            <Icon
                                glyph="offer"
                                label={`Discount coupon applied to this item: ${currentDiscount.code}. The discount has been automatically applied to your price.`}
                                aria-label={`Discount coupon applied to this item: ${currentDiscount.code}. The discount has been automatically applied to your price.`}
                                color="neutral"
                                size="xsmall"
                                className={styles['price-discounted-styles']}
                            />
                        }
                    >
                        {currentDiscount.code}
                    </Tooltip>
                )}
        </div>
    );
};
